import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';
import { IProductionStaticFilter } from '../models/filters/productionStaticFilter';
import { IProductionStaticForm } from '../models/forms/productionStaticForm';
import { IProductionStaticPDTO } from '../models/dtos/productionStaticPDTO';
import { API_CENTRE } from './config';

export default class ProductionStaticServices extends _o2sService {
   protected static override mainUrl:string = API_CENTRE + '/api/v1/ProductionStatics';
   protected static override getUrlFilter<F extends IProductionStaticFilter>(filter?: F): string {;
       let url = super.getUrlFilter(filter as IFilter);
       if (filter != null) 
       {
           if (filter.productionId != null)
               url += '&ProductionId=' + filter.productionId;
           if (filter.animalClassId != null)
               url += '&AnimalClassId=' + filter.animalClassId;
           if (filter.animalStatusId != null)
               url += '&AnimalStatusId=' + filter.animalStatusId;
           if (filter.formuleId != null)
               url += '&FormuleId=' + filter.formuleId;
       }
       return url;
   }

   public static override toDTO(dic: IProductionStaticForm): IProductionStaticPDTO {
       const dto = super.toDTO(dic) as IProductionStaticPDTO;
       return dto;
   }

}
